import React from "react";

const isTv = () => typeof window !== "undefined" && /^\/(tv|command)\/?$/.test(window.location.pathname);
const isMain = () => typeof window !== "undefined" && /^\/?$/.test(window.location.pathname);

export const PoweredByAVTech = () => (typeof window !== "undefined" && /^\/tv\/[ab]\/?$/.test(window.location.pathname)) ? null : (
  <div className={`avtech-badge ${isTv() ? "avtech-tv" : ""} ${isMain() ? "avtech-main" : ""}`} data-testid="powered-by-avtech" aria-hidden="true">
    <span className="avtech-c tl" /><span className="avtech-c tr" /><span className="avtech-c bl" /><span className="avtech-c br" />
    <span className="avtech-dim">POWERED BY</span> <span className="avtech-hi">A V TECH</span>
  </div>
);
